/**
 * Public clinics API — the names the app and tests import. Built once, for
 * camps and clinics alike, in publicTypedEventsAPI.ts.
 */
import { createPublicTypedEventsAPI } from "./publicTypedEventsAPI";

export type {
  PublicTypedEvent as PublicClinic,
  GuestRegistrationData as GuestClinicRegistrationData,
  BatchParticipant,
  BatchGuestRegistrationData as BatchGuestClinicRegistrationData,
  MemberLookupAthlete,
  MemberLookupResult,
  MemberVerifyResult,
} from "./publicTypedEventsAPI";

const api = createPublicTypedEventsAPI("clinic");

export const lookupMemberByEmail = api.lookupMemberByEmail;
export const verifyMemberByEmail = api.verifyMemberByEmail;
export const getPublicClinics = api.getPublicTypedEvents;
export const getPublicClinicById = api.getPublicTypedEventById;
export const registerGuestForClinic = api.registerGuestForTypedEvent;
export const confirmClinicPayment = api.confirmTypedEventPayment;
export const batchRegisterGuestForClinic = api.batchRegisterGuestForTypedEvent;
